import { DeskItem } from "./DeskItem";

export class OrganizeDeskGameConfig {
    public deskOrder: number[];
    public mapKey: string;
    public deskSupplies: DeskItem[];
    public deskGarbageItems: DeskItem[];
    // Whether or not there is a spill on the desk
    public spill: boolean;
}

/**
 * Represents the game state, passed around from scene to scene
 */
export class GameState {
    public deskNumber: number;
    public mapKey: string;
    public deskSupplies: DeskItem[];
    public deskGarbageItems: DeskItem[];
    public deskOrder: number[];
    public spill: boolean;
    public static NUMBER_OF_DESKS: number = 4;

    /**
     * Reference to the current game state at all times
     * Dynamically changes throughout the game!
     */
    public static current: GameState;
   
    constructor(options: OrganizeDeskGameConfig) {
        this.deskNumber = 1;
        let config = {...new OrganizeDeskGameConfig(), ...options};
        this.mapKey = config.mapKey;
        this.deskSupplies = config.deskSupplies;
        this.deskGarbageItems = config.deskGarbageItems;
        this.deskOrder = config.deskOrder;
        this.spill = config.spill;
    }    

}



// WEBPACK FOOTER //
// ./src/games/OrganizeDeskGame/objects/GameState.ts